<template>
  <!-- 房客管理 -->
  <div>
    <div class="tenant_title">会员查询</div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="手机号查询：">
        <el-input
          v-model="formInline.phone"
          placeholder="请输入会员电话"
          clearable
        ></el-input>
      </el-form-item>
      <!-- 选择时间 -->
      <el-form-item label="开通时间：" class="left_margin">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          size="small"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          prefix-icon="el-icon-date"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到期时间：" class="left_margin">
        <el-date-picker
          v-model="timetwo"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          size="small"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          prefix-icon="el-icon-date"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="会员状态:" class="left_margin">
        <el-select v-model="formInline.status" clearable placeholder="查看会员状态">
          <el-option
            v-for="(item, index) in status"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="left_margin">
        <el-button type="primary" @click="getTenant" class="inquire">搜索</el-button>
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="newly_built">
      <el-button
        type="primary"
        class="export"
        @click="export_user"
        v-if="premission('Export:Guest')"
        >导出</el-button
      >
    </div>
    <!-- 表单区域 -->
    <el-table
      ref="multipleTable"
      :data="tenanttableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="code" label="会员编号"> </el-table-column>
      <el-table-column prop="name" label="会员昵称"> </el-table-column>
      <el-table-column prop="phone" label="手机号"> </el-table-column>
      <el-table-column prop="statusDes" label="会员状态"> </el-table-column>
      <el-table-column prop="useNum" label="使用次数"> </el-table-column>
      <el-table-column prop="timeOpen" label="开通时间"> </el-table-column>
      <el-table-column prop="timeExpire" label="到期时间"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="details(scope.row)">查看</el-button></template
        >
      </el-table-column>
    </el-table>
    <!-- <div class="checkBox"></div> -->
    <!-- 分页 -->
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 15, 25, 50]"
          :page-size="8"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新建弹出框 -->
  </div>
</template>

<script>
import { addDateRange, money } from "../../utils/treating";
import { getlistVip } from "../../api/index";
import { exportVip } from "@/api/export";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  data() {
    var phonenumber = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号码不能为空"));
      } else if (!/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
        callback(new Error("手机号码格式错误!"));
      } else {
        callback();
      }
    };
    var validatorPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("账号不能为空"));
      } else if (!/^[a-zA-Z0-9]{6,18}$/.test(value)) {
        callback(new Error("账号格式错误,必须且只含有数字和字母，6-18位!"));
      } else {
        callback();
      }
    };

    return {
      // 表单验证
      rules: {
        customerName: [
          { required: true, message: "请填写客户真实姓名", trigger: "blur" },
        ],
        phonenumber: [{ validator: phonenumber, required: true, trigger: "blur" }],
        NewPassword: [{ required: true, validator: validatorPassword, trigger: "blur" }],
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 会员状态
      status: [
        {
          value: [],
          label: "全部",
        },
        {
          value: "0",
          label: "会员",
        },
        {
          value: "1",
          label: "已过期",
        },
      ],
      time: "",
      timetwo: "",
      // 搜索条件
      formInline: {
        phone: "",
        timetwo: "",
        pageNum: 1,
        pageSize: 5,
        status: "",
        timeStart: "",
        timeEnd: "",
        timeExpireStart: "",
        timeExpireEnd: "",
      },
      total: 0,
      currentPage: 1,
      tenanttableData: [],
      selectData: [],
    };
  },
  created() {
    this.getTenant();
  },
  methods: {
    export_user() {
      //会员导出
      var obj = {};
      if (this.selectData.length > 0) {
        obj.vipVoList = this.selectData;
      }
      exportVip(obj).then((result) => {
        console.log(result);
      });
    },
    // 重置
    reset() {
      (this.time = []),
        (this.timetwo = []),
        (this.formInline = {
          phone: "",
          timetwo: "",
          pageNum: 1,
          pageSize: 5,
          status: "",
          timeStart: "",
          timeEnd: "",
          timeExpireStart: "",
          timeExpireEnd: "",
        });

      this.getTenant();
    },
    // 取消按钮
    handleClose(done) {
      done();
    },
    // 全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 反选
    handleSelectionChange(arr) {
      console.log(arr);
      this.selectData = arr;
    },
    // 获取列表数据
    getTenant() {
      console.log(this.formInline.status);
      getlistVip({
        phone: this.formInline.phone,
        timeStart: this.time[0],
        timeEnd: this.time[1],
        timeExpireStart: this.timetwo[0],
        timeExpireEnd: this.timetwo[1],
        pageNum: this.formInline.pageNum,
        pageSize: this.formInline.pageSize,
        status: this.formInline.status,
      }).then((res) => {
        this.tenanttableData = res.data.data.list;
        console.log(this.tenanttableData);
        this.total = res.data.data.total;
      });
    },
    // 查看跳转详情
    details(e) {
      console.log(e);
      this.$router.push({
        name: "thememberlistDeta", //跳转的路径
        params: {
          phone: e.phone,
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getTenant();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.getTenant();
    },
  },
};
</script>

<style lang="less" scoped>
.tenant_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 250px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
/deep/.el-range-separator {
  width: 10%;
}
/deep/.el-range-editor.el-input__inner {
  float: left;
  margin-top: 2px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 80px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .export {
    width: 72px;
  }
  .el-button {
    text-align: center;
    padding: 0;
    height: 36px;
    margin-right: 14px;
  }
}
.money {
  margin-left: 26px;
  /deep/.el-form-item__content {
    width: 244px;
    padding-top: 3px;
  }
  div {
    float: left;
  }
  .zhi {
    width: 44px;
    text-align: center;
  }
  /deep/.el-input {
    width: 100px;
  }
  /deep/.el-input__inner {
    padding-left: 25px;
    float: left;
    width: 100px;
    height: 36px;
  }
}
.checkBox {
  width: 100%;
  height: 50px;
  background: #f2f2f2;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 0px;
}

.paging {
  margin-top: 40px;
  margin-left: 610px;
}
/deep/.el-table__header-wrapper {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  height: 50px;
  border-radius: 0px;
  .el-table__header {
    height: 50px;
    tr {
      height: 50px;
      th {
        background-color: #f2f2f2;
        text-align: center;
      }
    }
  }
}
/deep/ .el-table__row td {
  text-align: center;
  height: 60px;
  padding: 4px 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
/deep/.el-dialog__header {
  text-align: center;
  padding-top: 50px;
  font-size: 20px;
}
/deep/.el-dialog__body {
  padding: 30px 60px;
  .el-form-item {
    height: 36px;
    margin-bottom: 25px;
    .el-form-item__content {
      height: 36px;
      .gain {
        display: inline-block;
        width: 110px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        color: #b9b9b9;
      }
      .el-input__inner {
        height: 36px;
      }
    }
  }
}
/deep/.el-dialog {
  border-radius: 10px;
}
/deep/.el-dialog__footer {
  padding: 15px 60px 40px;
  .add_new_btn {
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
.verification {
  width: 370px;
}
.verification_btn {
  border: none;
  width: 110px;
  height: 36px;
  line-height: 36px;
  color: #f6b439;
  background-color: #fff;
}
</style>
